var _style, _path, _ellipse, _circle, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoDataSource(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "no_data_source_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 52 61",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".no_data_source_svg__st0,.no_data_source_svg__st2{fill-rule:evenodd;clip-rule:evenodd;fill:#979797}.no_data_source_svg__st2{fill:#f7f7f7}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "no_data_source_svg__st0",
    d: "M13.7 16.2c3.7.8 8.1 1.3 12.4 1.3 7.4 0 15.1-1.3 18.7-3.7v6.8c-2 2-8.3 3.8-16.7 4.1h-4c-8.4-.3-14.7-2.1-16.7-4.1v-2.7c.2.1.4.1.6.1 2.1 0 4.1-.7 5.7-1.8zm2-1.8c1.4-1.7 2.3-4 2.3-6.4 0-1.5-.3-2.9-.9-4.2 2.5-.5 5.5-.8 9-.8 11.3 0 17.8 3.1 18.6 6.2.1.1.1.2.1.3v1.7c-2.1 2.1-9.2 4.1-18.7 4.1-3.9 0-7.5-.3-10.4-.9zm-7.8-2.8c-.2-.1-.3-.3-.5-.4V9.5c0-.1 0-.2.1-.4.4-1.3 1.6-2.5 3.8-3.6-1.2 1.9-2.5 4.1-3.4 6.1zm20.2 15.3c5.5-.1 9.8-.9 13-2 1.5-.5 2.8-1.1 3.8-1.7V30c-2.1 2.1-9.3 4.1-18.7 4.1S9.6 32.1 7.5 30v-6.8c1 .6 2.2 1.2 3.7 1.7 3.2 1.1 7.5 1.8 13 2h2c.6.1 1.2 0 1.9 0zM7.4 32.7c3.1 2.1 9.5 3.8 18.7 3.8s15.6-1.7 18.7-3.8v5.9c0 .1 0 .2-.1.4-.9 3.5-8.8 6.2-18.6 6.2S8.4 42.6 7.5 39c-.1-.1-.1-.2-.1-.3v-6z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26,
    cy: 59.7,
    rx: 18,
    ry: 1,
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#979797"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "no_data_source_svg__st0",
    cx: 8,
    cy: 8,
    r: 8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "no_data_source_svg__st2",
    d: "M6.2 4.1l5.7 5.7c.2.2.2.5 0 .7l-1.4 1.4c-.2.2-.5.2-.7 0L4.1 6.2c-.2-.2-.2-.5 0-.7l1.4-1.4c.2-.2.5-.2.7 0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "no_data_source_svg__st2",
    d: "M11.9 6.2l-5.7 5.7c-.2.2-.5.2-.7 0l-1.4-1.4c-.2-.2-.2-.5 0-.7l5.7-5.7c.2-.2.5-.2.7 0l1.4 1.4c.2.2.2.5 0 .7z"
  })));
}
export default SvgNoDataSource;